<template>
  <div class="btn-panel">
    <div v-for="btn in btn_list" class="btn num-pad-btn"
      @click="$emit('btn-pressed', btn )">
      {{btn}}
    </div>
  </div>

</template>

<style scoped lang="scss">
@import '@/assets/styles/numpad/sm.scss';
@import '@/assets/styles/numpad/md.scss';
@import '@/assets/styles/numpad/lg.scss';
@import '@/assets/styles/numpad/xlg.scss';
</style>

<script setup>

const btn_list = [
    '7', '8', '9', 'Clr',
    '4', '5', '6', 'Del',
    '1', '2', '3', ' ',
    ' ', '0', ' ', 'Roll'
]



</script>
